export default __webpack_public_path__ + "static/media/fileIcon.d87cba0d.svg";